import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateReportJobDto } from './create-report-job.dto';

/**
 * Update report job DTO
 */
export class UpdateReportJobDto extends CreateReportJobDto {
	@TransformInt()
	id!: number;
}
